import { api } from "@/lib/api";

// Port of frontend/src/api/quote_builder.ts — stateless, no persistence.
export const quoteBuilderApi = {
  calculate: (body) => api("/quote-builder/calculate", { method: "POST", body }),
  projectPresets: () => api("/quote-builder/project-presets"),
  calculateProject: (body) => api("/quote-builder/calculate-project", { method: "POST", body }),
};
